import { colors } from '../../colors';
var service = {
  bgColor: colors.whiteish,
  borderColor: colors.overcast,
  bgColorBlade: colors.whiteish,
  carouselDotColor: colors.duskBlue,
  linkColor: colors.rust,
  textColorDark: colors.graphite,
  textColorLight: colors.white
};
export default service;